import { ROUTE } from '../../../routes';
import { ButtonTypeTokens, DocumentPickerState, } from '@voltmoney/schema';
import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import { getAppHeader } from '../../../configs/config';
import { nextStepCredStepper, uploadToS3Bucket } from '../../../configs/utils';
import { Platform } from 'react-native';
let documentUploadUrlMap = {
    frontDocURL: null,
    backDocURL: null,
};
const validation = {
    isFrontDocUploaded: false,
    isBackDocUploaded: false,
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const triggerAction = async (action, _datastore, { setDatastore, network, navigate, instrumentTrack }) => {
    instrumentTrack('UPLOAD_PAN_CONFIRM_BUTTON_CLICKED');
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
        loading: true,
    });
    const response = await network.get(`${api.documentValidatePOIManual}${applicationId}`, { headers: await getAppHeader() });
    await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
        loading: false,
    });
    if (response.status === 200) {
        user.linkedApplications[0] = response.data.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        const routeObj = await nextStepCredStepper();
        await navigate(routeObj.routeId, routeObj.params);
    }
};
export const documentPickerAction = async (action, _datastore, { network, setDatastore, instrumentTrack }) => {
    instrumentTrack('UPLOAD_PAN_BUTTON_CLICKED', {
        type: 'front',
        status: 'TRUE',
    });
    if (action.payload.value) {
        let fileExtension = '';
        if (action.payload.value.name === undefined) {
            fileExtension = action.payload.value.fileName.split('.').pop();
        }
        else {
            fileExtension = action.payload.value.name.split('.').pop();
        }
        await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, action.payload.widgetID, {
            state: DocumentPickerState.LOADING,
        });
        if (Platform.OS !== 'web') {
            uploadToS3Bucket(documentUploadUrlMap.frontDocURL, action.payload.value, await getContentType(fileExtension))
                .then(async () => {
                validation.isFrontDocUploaded = true;
                await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, action.payload.widgetID, {
                    state: DocumentPickerState.SUCCESS,
                });
                await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
                    type: ButtonTypeTokens.LargeFilled,
                });
                return;
            })
                .catch(async () => {
                instrumentTrack('UPLOAD_PAN_BUTTON_CLICKED', {
                    type: 'front',
                    status: 'FALSE',
                });
                await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, action.payload.widgetID, {
                    state: DocumentPickerState.DEFAULT,
                });
            });
        }
        const response = await network.put(action.payload.widgetID === 'frontSide'
            ? documentUploadUrlMap.frontDocURL
            : documentUploadUrlMap.backDocURL, action.payload.value, {
            headers: { 'Content-Type': getContentType(fileExtension) },
        });
        if (response.status === 200) {
            if (action.payload.widgetID === 'frontSide') {
                validation.isFrontDocUploaded = true;
            }
            await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, action.payload.widgetID, {
                state: DocumentPickerState.SUCCESS,
            });
        }
        else {
            await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, action.payload.widgetID, {
                state: DocumentPickerState.DEFAULT,
            });
        }
    }
    if (validation.isFrontDocUploaded) {
        await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onPageLoad = async (action, _datastore, { network, removeWidgets, appendWidgets, setDatastore }) => {
    validation.isFrontDocUploaded = false;
    await setDatastore(ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL, 'continue', {
        type: ButtonTypeTokens.LargeOutline,
    }); // reset continue button
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const documentUrlResponse = await network.post(`${api.kycDocumentPOIManual}${applicationId}`, { documentType: 'PAN' }, { headers: await getAppHeader() });
    documentUploadUrlMap = documentUrlResponse.data.stepResponseObject;
};
export const getContentType = fileExtension => {
    switch (fileExtension) {
        case 'pdf':
            return 'application/pdf';
        case 'png':
            return 'image/png';
        case 'jpg':
            return 'image/jpeg';
        case 'jpeg':
            return 'image/jpeg';
        default:
            return 'application/pdf';
    }
};
